// frontend/src/service/file-service.ts
import axiosInstance from "../configuration/api";

interface FileResponse {
  success: boolean;
  file?: {
    name: string;
    originalName: string;
    mimetype: string;
    extension: string;
    destination: string;
    path: string;
    size: number;
  };
  message?: string;
}
interface MultiFileResponse {
  success: boolean;
  files?: FileResponse[];
  message?: string;
}
export const uploadAttachment = async (file: File): Promise<FileResponse> => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const baseUrl = process.env.REACT_APP_API_HOST;
    const response = await axiosInstance.post(
      `${baseUrl}/api/v1/file/single`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("File upload error:", error);
    return {
      success: false,
      message: error.response?.data?.message || "File upload failed",
    };
  }
};

export const uploadMultipleAttachments = async (
  files: File[]
): Promise<MultiFileResponse> => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append("files", file); // backend expects "files"
  });

  try {
    const baseUrl = process.env.REACT_APP_API_HOST;
    const response = await axiosInstance.post(
      `${baseUrl}/api/v1/file/multi`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Multi-file upload error:", error);
    return {
      success: false,
      message: error.response?.data?.message || "File upload failed",
    };
  }
};
